jQuery(document).ready(function($) {

    initSlider(); 

});

function initSlider () {
	if (jQuery('.testimonials-swiper').length) {
		new Swiper('.testimonials-swiper', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 10,
			pagination: {
				el: ".testimonials-swiper .swiper-pagination",
				clickable: true
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 15
				},
				992: {
					slidesPerView: 2.5,
					spaceBetween: 20
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 20
				}
			}
		});
	}
}